import bus from '/javascripts/bus'
import UI from '/javascripts/utils/UI'

UI({
  component: '.js-overviewList',
  listItems: ['.js-overviewList-item']
}, ({ listItems }) => {
  bus.on('isTouch', handleTouch)

  listItems.forEach(item => {
    item.addEventListener('mouseenter', onMouseEnter)
    item.addEventListener('mouseleave', onMouseLeave)
  })

  function handleTouch() {
    listItems.forEach(item => {
      item.removeEventListener('mouseenter', onMouseEnter)
      item.removeEventListener('mouseleave', onMouseLeave)
    })
  }

  function onMouseEnter({ target }) {
    listItems.forEach(e => e.classList.add('is-transparent'))
    target.classList.remove('is-transparent')
  }

  function onMouseLeave({ target }) {
    listItems.forEach(e => e.classList.remove('is-transparent'))
  }
})
